import $ from 'jquery';

export default () => {
	let popoverContentId;
	let popoverContainer;

	$('[data-toggle="popover"]')
		.popover({
			html: true,
			title() {
				popoverContentId = $(this).data('popover-target');
				popoverContainer = $(`[data-popover-trigger='${popoverContentId}']`);
				const popoverTitle = popoverContainer.data('popover-title') ?? '';
				const showCloseIcon = popoverContainer.is('[data-show-close-icon]');
				const popoverCloseIcon = showCloseIcon
					? `<i id="popoverCloseIcon-${popoverContentId}" class="fas fa-times popover-close-icon" aria-hidden="true"></i>`
					: '';
				return `${popoverTitle}${popoverCloseIcon}`;
			},
			content: () => popoverContainer.html(),
		})
		.on('inserted.bs.popover', () => {
			$(`#popoverCloseIcon-${popoverContentId}`).click(({ target }) => {
				$(target).closest('.popover').popover('hide');
			});
		});
};
